export const secrets = {
  sentryDsn: 'https://b8d7688b3c2f36c48b0ddb0ebb95cd6a@o4510400014188544.ingest.us.sentry.io/4511058173034496',
  DOWNLOAD_FILE_URL: 'https://osmos-v2-images-2026.s3.us-west-2.amazonaws.com/download_queu/temp/',
  GOOGLE_MAP: 'AIzaSyBpNA_1fGzE5j9axh9K2Ok0B-5T1IE15i4',
  UPLOAD_NOTE_ATTACHMENT: 'https://osmos-v2-images-2026.s3.us-west-2.amazonaws.com/upload_note_attachment/',
  RSA_PUBLIC_KEY: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqNuH0SFsz/urWi/gAh6b
2v4/4HJ/okH96WwUvfoJ7yjJl92GBLKgJgbIj8hlwySYWdRWUaph/EiabHQMqW2g
o2SKkk3gMFI9EmGAyqmmTfn5TZEgR9Hn6IjGEwTZPArbSqCe5+gdM39+7jqgs3te
5rLZEWwCnO4ry5H/1LEk3vY0Z+KTVeoHHLddLHFoZKj8DlnCddrWrLzkyUOvFBlb
SUFnaMfQUSha6CiISH5UR19HJDL2EnStHgE0JjuXVL3lYpdeOrLBwvLkG+qbAa8g
xCz/D0EMzZVBnxJ4F+9o8C46f9dlayd3PquyPvqVAPF5kByh9ZbJ7JTZnhY/XYnF
kQIDAQAB
-----END PUBLIC KEY-----`,
};